export default __webpack_public_path__ + "static/media/integrity-navy.4d1afaab.svg";